import { ArrowLeft, ArrowRight } from '@phosphor-icons/react';
import { Link, useParams } from 'react-router-dom';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Callout } from '../components/Callout';
import { MediaFrame } from '../components/MediaFrame';
import { Reveal } from '../components/Reveal';
import { ResponsiveImage } from '../components/ResponsiveImage';
import { getGuide, guides } from '../content/site';
import { NotFound } from './NotFound';

export function GuideDetail() {
  const { guideSlug } = useParams();
  const guide = getGuide(guideSlug);
  if (!guide) return <NotFound />;
  const nextGuide = guides[(guides.indexOf(guide) + 1) % guides.length];

  return (
    <>
      <article className="guide-detail">
        <header className="guide-detail__hero section-shell">
          <Breadcrumbs items={[{ to: '/guides', label: 'Guides' }, { label: guide.title }]} />
          <Reveal><span>{guide.readTime}</span><h1>{guide.title}</h1><p>{guide.description}</p></Reveal>
          <Reveal delay={0.08} variant="media">
            <MediaFrame className="guide-detail__media">
              <ResponsiveImage
                src={guide.image}
                alt={guide.imageAlt}
                width="1600"
                height="900"
                fetchPriority="high"
                sizes="min(calc(100vw - 40px), 1320px)"
              />
            </MediaFrame>
          </Reveal>
        </header>
        <div className="guide-detail__body section-pad section-shell">
          <aside><Link to="/guides"><ArrowLeft aria-hidden="true" size={17} /> All guides</Link><p>Project-specific recommendations should follow the conditions at your property.</p></aside>
          <div>
            {guide.sections.map((section) => <Reveal as="section" key={section.heading}><h2>{section.heading}</h2>{section.body.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</Reveal>)}
            <Link className="next-guide" to={`/guides/${nextGuide.slug}`}><span>Read next</span><strong>{nextGuide.title}</strong><ArrowRight aria-hidden="true" size={22} /></Link>
          </div>
        </div>
      </article>
      <Callout />
    </>
  );
}
